import React from 'react';

const HealthCheck = () => {
    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>Health Check</h1>
            <p>Status: OK</p>
            <p>Application is running.</p>
        </div>
    );
};

export default HealthCheck;